import React from "react";
import ModalUI from "../ui/ModalUI";
import CustomButton from "../CustomButton";
import ShortTextInput from "../Inputs/ShortTextInput";
import CustomSelectBox from "../Inputs/CustomSelectBox";
import { addCustomField, updateCustomField } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import { useFormik } from "formik";
import * as Yup from "yup";

function AddTaskField({ show, handleClose, currentField, projectId, refresh }) {
  return (
    <ModalUI
      show={show}
      handleClose={handleClose}
      title={currentField ? "Update Task Field" : "Create New Task Field"}
    >
      <AddTaskFieldForm
        currentField={currentField}
        handleClose={handleClose}
        projectId={projectId}
        refresh={refresh}
      />
    </ModalUI>
  );
}

function AddTaskFieldForm({ currentField, handleClose, projectId, refresh })
 
{
  console.log("currentField", currentField);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentField?.name || "",
      type: currentField?.type?.toLowerCase() || "text"
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Field name is required"),
      type: Yup.string().required("Field type is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        let response;
        if (currentField) {
          response = await updateCustomField(projectId, currentField.id, {
            name: values.name,
            type: values.type,
          });

          if (response?.status === 200) {
            showToast("Task field updated successfully.", "success");
            handleClose();
          } 
        } else {
          response = await addCustomField(projectId, values);

          if (response?.status === 201) {
            showToast("Task field added successfully.", "success");
            handleClose();
          } else if (response?.status === 409) {
            showToast("Field name already exists. Try a different name.", "error");
          } else {
            throw new Error("Failed to add");
          }
        }

        
        refresh();
      } catch (error) {
        showToast(
          currentField ? "Failed to update task field." : "Failed to add task field.",
          "error"
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <ShortTextInput
        label="Field Name"
        name="name"
        id="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        placeholder="Enter field name"
        error={formik.touched.name && formik.errors.name}
      />

      <div className="mt-3">
        <CustomSelectBox
          label="Field Type"
          id="type"
          name="type"
          value={formik.values.type}
          onChange={(e) => formik.setFieldValue("type", e.target.value)}
          options={[
            { value: "text", label: "Text" },
            { value: "number", label: "Number" },
            { value: "date", label: "Date" },
            { value: "boolean", label: "Boolean" },
          ]}
          helperText={formik.touched.type && formik.errors.type}
          fullWidth={true}
        />
      </div>

      <div className="d-flex align-items-center justify-content-center mt-4 pb-3">
        <CustomButton type="submit" disabled={formik.isSubmitting}>
          {formik.isSubmitting
            ? currentField
              ? "Updating..."
              : "Adding..."
            : currentField
            ? "Update"
            : "Add"}
        </CustomButton>
      </div>
    </form>
  );
}

export default AddTaskField;
